import { createContext } from 'react';
import { PipelineContextProps } from './PipelineContext.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const PipelineContext = createContext<PipelineContextProps>(undefined);

export default PipelineContext;
